'use strict';

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */

module.exports = require('react');


//////////////////
// WEBPACK FOOTER
// ./~/fixed-data-table-2/internal/React.js
// module id = 18
// module chunks = 0